import React from 'react';
import PropTypes from 'prop-types';
import SMOwnerResource from 'resources/SMOwnerResource';
import SMFormSubmitButton from 'components/dashboard/form/SMFormSubmitButton';
import SMFormValidationMessage from 'components/dashboard/form/SMFormValidationMessage';
import SMFormTextField from 'components/dashboard/form/SMFormTextField';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMOReservationDialogHeaderView from './SMOReservationDialogHeaderView';

class SMOReservationRefundView extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      errors: []
    };
  }
  
  trackPageEvent(label) {
    SMTrackHelper.pageEvent(label);
  }

  formDidSubmit(e){
    e.preventDefault();
    this.trackPageEvent('od sumit refund_reservation');
    let formData = new FormData(e.currentTarget);
    $(this.refs.form).startLoading();
    SMOwnerResource.refund(this.props.reservation, formData, (data, error, xhr)=>{
      $(this.refs.form).stopLoading();
      if (!error) {
        if(this.props.delegate && typeof this.props.delegate.reservationDidRefund === 'function'){
          this.props.delegate.reservationDidRefund(data, xhr);
        }
      } else {
        let errors = xhr.responseJSON.errors;
        this.setState({
          errors: []
        });
        if(this.props.delegate && typeof this.props.delegate.reservationDidFailToRefund === 'function'){
          this.props.delegate.reservationDidFailToRefund(error, xhr);
        }
      }
    });
  }
  
  render() {
    let reservation = this.props.reservation;
    let maxAmount = parseInt(reservation.billing.total_amount_with_tax);
    return (
      <div ref="form" className="form-casette maincol-lightbox__form">
        <SMOReservationDialogHeaderView />
        <h2 className="dashboard-title mb30 ta-c" 
          dangerouslySetInnerHTML={{__html: I18n.t("dashboard.text_000030")}} />
        <form onSubmit={this.formDidSubmit.bind(this)}>
          <div className="form-box">
            <h3 className="dashboard-title mb20">
              <span className="icon-form icon-form__required">{I18n.t("dashboard.label_000025")}</span>
              {I18n.t("dashboard.label_000141")}
              <span className="dashboard-title__supplement ml15">（0 〜 {maxAmount} まで）</span>
            </h3>
            <SMFormTextField
              delegate={this.props.delegate}
              type="number"
              name="refunded_amount"
              value={maxAmount} 
              max={maxAmount} 
              min={0} 
              placeholderText={maxAmount}
              options={{className:'w400 mr20'}}
               />
            <SMFormValidationMessage 
              name="refunded_amount" 
              errorText={SMFormatHelper.errorText("Reservation", "refunded_amount", this.state.errors)} />
          </div>
          <div className="ta-c mb30">
            <SMFormSubmitButton 
              title={I18n.t("dashboard.label_000140")} 
              options={{className: "button-green maincol-buttonarea__button"}} />
          </div>
        </form>
      </div>
    );
  }
}
SMOReservationRefundView.propTypes = {
  delegate: PropTypes.object,
  reservation: PropTypes.object.isRequired
};
export default SMOReservationRefundView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/reservations/SMOReservationRefundView.jsx